import { render, staticRenderFns } from "./CommentActivity.vue?vue&type=template&id=dd525028"
import script from "./CommentActivity.vue?vue&type=script&lang=js"
export * from "./CommentActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports